import { render, staticRenderFns } from "./Frameworks.vue?vue&type=template&id=1b07d7f3&scoped=true"
import script from "./Frameworks.vue?vue&type=script&lang=js"
export * from "./Frameworks.vue?vue&type=script&lang=js"
import style0 from "./Frameworks.vue?vue&type=style&index=0&id=1b07d7f3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b07d7f3",
  null
  
)

export default component.exports